// Global
import React from 'react';

import styles from './PullQuote.module.scss';
import { Themes } from 'lib/themes';
import { BrandAndThemeProvider } from 'components/helpers/ContextProvider/BrandAndThemeContext';

export interface PullQuoteProps {
  theme: Themes;
  quotation: React.ReactNode;
  name: React.ReactNode;
  title: React.ReactNode;
}

export const PullQuote = (props: PullQuoteProps) => {
  return (
    <BrandAndThemeProvider
      theme={props.theme}
      data-component="authorable/shared/content/pullquote/pullquote"
    >
      <div className={styles.pullQuoteBgWrapper}>
        <div className={styles.pullQuoteWrapper}>
          <div className={styles.pullQuoteContentWrapper}>
            <div className={styles.pullQuoteCopyContainer}>
              <div className={styles.quotationMark}>“</div>
              <div className={styles.quotationHeadingContainer}>
                <blockquote className={styles.quotationHeading}>{props.quotation}</blockquote>
              </div>
              <div className={styles.nameAndTitleWrapper}>
                <div className={styles.quotationNameStyle}>{props.name}</div>
                {props.title && <div className={styles.quotationTitleStyle}>{props.title}</div>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </BrandAndThemeProvider>
  );
};
